/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { StrictMode } from 'react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import App from './App.jsx'
import { initClarity } from './lib/clarity.js'
import { initPosthog } from './lib/posthog.js'
import './styles/landing.css'
import './styles/pages.css'

initClarity()
initPosthog()
import('./lib/consoleBanner.js').then((m) => m.printConsoleBanner()).catch(() => {})
const root = document.getElementById('root')
if (root.firstElementChild) {
  hydrateRoot(root, <StrictMode><App path={location.pathname} /></StrictMode>)
} else {
  createRoot(root).render(<StrictMode><App path={location.pathname} /></StrictMode>)
}
